import {
  getMembersByBuildingId,
  uploadMembersByBuildingId,
} from "../../../../Redux/Buildings/BuildingActions";
import MembersTemplate from "../../../../Assets/MemberTemplate.csv";
import { AppDispatch, RootState } from "../../../../Redux/store";
import React, { useEffect, useRef, useState } from "react";
import toastHelper from "../../../../Util/toastHelper";
import { useDispatch, useSelector } from "react-redux";
import { GridReadyEvent } from "ag-grid-community";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import styles from "./Members.module.scss";
import { ColDef } from "ag-grid-community";
import { useNavigate } from "react-router";

interface MembersType {
  name: string;
  email: string;
  idNumber: string;
  isActive: boolean;
}

const columnDefs: ColDef<MembersType>[] = [
  {
    headerName: "Name",
    field: "name",
    flex: 1,
    minWidth: 150,
  },

  {
    headerName: "Email",
    field: "email",
    flex: 1,
    minWidth: 100,
  },

  {
    headerName: "ID Number",
    field: "idNumber",
    flex: 1,
    minWidth: 150,
  },

  {
    headerName: "Status",
    field: "isActive",
    flex: 1,
    minWidth: 100,
  },
];

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

interface Props {
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  buildingId: string;
}

function Members(props: Props) {
  const { setActiveTab, buildingId } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const ref = useRef<HTMLInputElement>(null);
  const [rowData, setRowData] = useState<MembersType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [search, setSearch] = useState("");
  const { getMembersByBuildingIdList, uploadMembersLoading } = useSelector(
    (state: RootState) => state.buildings,
  );

  const filteredRowData = rowData?.filter((item) => {
    return (
      item?.email?.toLowerCase().match(search.toLowerCase()) ||
      item?.idNumber?.toLowerCase().match(search.toLowerCase()) ||
      item?.name?.toLowerCase().match(search.toLowerCase())
    );
  });

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    if (getMembersByBuildingIdList) {
      setRowData(getMembersByBuildingIdList);
    }
  }, [getMembersByBuildingIdList]);

  useEffect(() => {
    if (buildingId) {
      dispatch(getMembersByBuildingId({ buildingId }));
    }
  }, [buildingId, dispatch]);

  const uploadMembersHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file && file.type === "text/csv") {
      if (!uploadMembersLoading) {
        if (buildingId) {
          dispatch(
            uploadMembersByBuildingId({
              buildingId,
              file,
            }),
          );
        }
      } else {
        toastHelper.error("Please upload a valid CSV file");
      }
    }
  };

  const nextHandler = () => {
    if (Array.isArray(getMembersByBuildingIdList) && rowData.length > 0) {
      navigate("/admin/buildings", {
        replace: true,
      });
    } else {
      toastHelper.error("Please upload a valid CSV file and add members");
    }
  };

  const templateDownloadHandler = () => {
    const link = document.createElement("a");
    link.href = MembersTemplate;
    link.download = "MembersTemplate.csv";
    link.click();
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.topContainer}>
        <div className={styles.buttonContainer}>
          <input
            type="file"
            hidden
            ref={ref}
            accept=".csv"
            onChange={uploadMembersHandler}
          />
          <button
            className={styles.button}
            onClick={() => {
              ref.current!.value = "";
              ref.current?.click();
            }}
          >
            Upload Member
          </button>

          <button className={styles.button} onClick={templateDownloadHandler}>
            Download Template
          </button>
        </div>
        <div className={styles.searchContainer}>
          <div className={styles.searchContainerInner}>
            <input
              type="text"
              className={styles.input}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e?.target?.value || "")}
            />
            <div className={styles.iconContainer} onClick={() => setSearch("")}>
              <IoCloseSharp className={styles.icon} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.gridContainer}>
        <AgGridReact
          className={styles.grid}
          rowData={filteredRowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[5, 10, 20, 50, 100]}
          animateRows={true}
          domLayout="autoHeight"
        />
      </div>

      <div className={styles.buttonContainer}>
        <button className={styles.finishButton} onClick={nextHandler}>
          Finish
        </button>
        <button
          className={styles.backButton}
          onClick={() => setActiveTab("buildingInformation")}
        >
          Back
        </button>
      </div>
    </div>
  );
}

export default Members;
